import { render, staticRenderFns } from "./RlsForm.vue?vue&type=template&id=a0f98f20&scoped=true&"
import script from "./RlsForm.vue?vue&type=script&lang=js&"
export * from "./RlsForm.vue?vue&type=script&lang=js&"
import style0 from "./RlsForm.vue?vue&type=style&index=0&id=a0f98f20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f98f20",
  null
  
)

export default component.exports